<template>
  <div class="course">
    <div
      class="course-image">
      <img :src="course.course_thumbnail" class="image-title">
    </div>

    <div class="container-fluid">
      <h2 class="course-title">{{ course.course_title }}</h2>
      <div class="course-info row no-gutters">
        <div class="col-8">
          <p class="tutor-name">ผู้สอน : {{ course.course_instructor }}</p>
          <p class="tutor-career">ตำแหน่งอาชีพผู้สอน : {{ course.course_instructor_position }}</p>
        </div>
        <div class="col-4">
          <h6 class="score-heading">คะแนนรวม</h6>
          <p class="score">{{ this.calScore() }}/100</p>
        </div>
      </div>
    </div>

    <!-- Course tabs -->
    <b-tabs
      class="tabs-learning"
      fill>
      <b-tab class="tab-course-info" title="รายละเอียด" active>
        <div class="container-fluid">
          <div class="course-info-wrapper">
            <div class="icon">
              <img src="../../assets/img/learning/course-description-icon.svg" alt="Course Description Icon">
            </div>
            <div class="content">
              <h6 class="title">คำอธิบายหลักสูตร</h6>
              <div class="description" v-html="course.course_detail"></div>
            </div>
          </div>

          <div class="course-info-wrapper">
            <div class="icon">
              <img src="../../assets/img/learning/course-user-icon.svg" alt="Course User Icon">
            </div>
            <div class="content">
              <h6 class="title">หลักสูตรนี้เหมาะสำหรับ</h6>
              <div class="description">{{ course.course_for_text }}</div>
            </div>
          </div>

          <div class="course-info-wrapper">
            <div class="icon">
              <img src="../../assets/img/learning/course-content-icon.svg" alt="Course Content Icon">
            </div>
            <div class="content">
              <h6 class="title">ระดับเนื้อหา</h6>
              <div class="description">ระดับเริ่มต้น (Beginner)</div>
            </div>
          </div>

          <template v-if="course.has_certificate">
            <div class="course-info-wrapper">
              <div class="icon">
                <img src="../../assets/img/learning/course-cert-icon.svg" alt="Course Content Icon">
              </div>
              <div class="content">
                <h6 class="title">การรับวุฒิบัตร</h6>
                <div class="description">เข้าเรียนไม่น้อยกว่า 80% ของเวลาเรียนทั้งหมด</div>
              </div>
            </div>
          </template>
        </div>
      </b-tab>

      <b-tab class="tab-course-score" title="ผลการเรียน">
        <template v-for="(question, index) in course.get_course_questions">
          <div :key="index" class="course-score">
            <div class="container-fluid">
              <div class="course-score-wrapper">
                <div :class="{ assessed: question.score }" class="icon">
                  <template v-if="question.score">
                    <img src="../../assets/img/learning/course-check-icon.svg" alt="Course Description Icon">
                  </template>
                </div>
                <div class="content">
                  <h6 class="title">{{ question.question_set.set_name }}</h6>
                  <!--<div class="description">{{ courseResult.description }}</div>-->
                </div>
                <template v-if="question.score">
                  <h6 class="score">{{ question.score }}/{{ question.maxScore }}</h6>
                </template>

                <template v-if="!question.score">
                  <h6 class="score">ยังไม่มีผลการทดสอบ</h6>
                </template>
              </div>

              <div class="actions">
                <template v-if="question.score">
                  <button class="btn btn-learning btn-sm" @click="showEvaluateModal(question)">
                    ผลประเมิน
                  </button>
                </template>
              </div>
            </div>
          </div>
        </template>
      </b-tab>
    </b-tabs>

    <!-- Assessment modal -->
    <b-modal
      id="assessment-modal"
      class="assessment-modal"
      centered
      hide-header
      hide-footer>
      <template v-if="evaluateQuestion">
        <h6 class="text-center">{{ evaluateQuestion.question_set.set_name }}</h6>

        <div class="evaluates">
          <template v-for="(evaluate, index) in evaluateQuestion.evaluate">
            <div :key="index" class="evaluate">
              <div class="container-fluid">
                <div class="evaluate-score-wrapper">
                  <div class="content">
                    <h6 class="title">{{ evaluate.evaluate.title }}</h6>
                  </div>
                  <template v-if="evaluate.value">
                    <h6 class="score">{{ evaluate.value }}%</h6>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div class="m-3">
          <button
            class="btn btn-round btn-block btn-learning"
            @click="hideEvaluateModal">
            ตกลง
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'course-detail',

    props: {
      course: {
        type: Object,
        default: null
      }
    },

    watch: {
      course: val => {
        this.course = val
      }
    },

    data () {
      return {
        evaluateQuestion: null
      }
    },
    methods: {
      showEvaluateModal (question) {
        this.evaluateQuestion = question
        return this.$bvModal.show('assessment-modal')
      },
      hideEvaluateModal () {
        return this.$bvModal.hide('assessment-modal')
      },
      calScore () {
        let score = 0
        if (this.course.score !== 0) {
          score = (this.course.score / this.course.maxScore) * 100
        }
        return parseInt(score)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/styles";

  .image-title{
    display:block;
    marign-top: auto;
    marign-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    object-fit: contain;
    height: 100%;
  }

  .course-image {
    height: 30vw;
    margin-top: 15px;
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .course-title {
    @extend .flex-grow-1;
    line-height: 1;
    font-size: 18px;
  }

  .course-info {
    margin-bottom: 36px;
  }

  .tutor-name, .tutor-career, .score-heading, .score {
    margin: 0;
    font-size: 14px;
  }

  .score-heading, .score {
    @extend .text-center;
  }

  .tab-course-info {
    .course-info-wrapper {
      @extend .d-flex;
      @extend .align-items-center;
      padding: 20px 0;
      .icon {
        @extend .d-flex;
        @extend .align-self-baseline;
        border: 1px solid $learn-color;
        box-sizing: border-box;
        border-radius: 50%;
        padding: 5px;
        margin: 0 15px;
        width: 30px;
        height: 30px;
        flex: none;
        img {
          margin: auto;
        }
      }
      .content {
        h6, .description {
          margin-bottom: 0;
          font-size: 14px;
        }
      }
    }
  }

  .tab-course-score {
    .course-score {
      padding: 20px 0;
      &:not(:last-child) {
        border-bottom: 1px solid $border-color;
      }
      .course-score-wrapper {
        @extend .d-flex;
        @extend .align-items-center;
        .icon {
          @extend .d-flex;
          border: 1px solid $learn-color;
          box-sizing: border-box;
          border-radius: 50%;
          padding: 5px;
          margin: 0 15px;
          width: 30px;
          height: 30px;
          flex: none;
          img {
            margin: auto;
          }
          &.assessed {
            background-color: $learn-color;
          }
        }
        .content {
          @extend .flex-grow-1;
          h6, .description {
            margin-bottom: 0;
            font-size: 14px;
          }
        }
        .score {
          @extend .align-self-baseline;
          font-size: 14px;
          padding-top: 5px;
        }
      }
      .actions {
        @extend .text-right;
        height: 30px;
      }
    }
  }
</style>

<style lang="scss">
  @import "../../styles/styles";

  .evaluates {
    .evaluate {
      padding: 20px 0;
      &:not(:last-child) {
        border-bottom: 1px solid $border-color;
      }
      .evaluate-score-wrapper {
        @extend .d-flex;
        @extend .align-items-center;
        .icon {
          @extend .d-flex;
          border: 1px solid $learn-color;
          box-sizing: border-box;
          border-radius: 50%;
          padding: 5px;
          margin: 0 15px;
          width: 30px;
          height: 30px;
          flex: none;
          img {
            margin: auto;
          }
          &.assessed {
            background-color: $learn-color;
          }
        }
        .content {
          @extend .flex-grow-1;
          h6, .description {
            margin-bottom: 0;
            font-size: 14px;
          }
        }
        .score {
          @extend .align-self-baseline;
          font-size: 14px;
        }
      }
      .actions {
        @extend .text-right;
        height: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/learning/CourseDetail.component.vue